import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/styles';

const CustomButton = styled(Button)(({ theme }) => ({
    borderRadius: '9px',
    padding: '14px 7px',
    margin: '-3px',
    // marginBottom: '10px',
    fontWeight: 'bold',
    fontSize: '14px',
    textTransform: 'none',
    backgroundImage: 'linear-gradient(180deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 50%)'
}));

const PrimaryButton = ({ children, ...props }) => (
    <CustomButton
        variant="contained"
        sx={{
            backgroundColor: '#0c0961',
            boxShadow: 'inset 0px 8px 12px rgba(11, 121, 208, 0.5)',
            backgroundImage: 'linear-gradient(to bottom, #1A8BDB, #0c0961)'
            // '&:hover': {
            //     backgroundColor: '#0A6FB8'
            // }
        }}
        {...props}
    >
        {children}
    </CustomButton>
);

export default PrimaryButton;
